import state from './states';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  name: 'orderMethods',
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-order-methods/store/index.js